import Request from './Request';

class NationalRequest extends Request {
    prefix = '/admin/national-management/';

    async getList(params) {
        let url = this.prefix + 'index';
        return await this.get(url, params);
    }

    async create(params) {
        let url = this.prefix + 'create';
        return await this.post(url, params, {
            'api-action': 'NationalRequest-create',
            'api-action-meta': params.code
        });
    }

    async show(id) {
        let url = this.prefix + id;
        return await this.get(url);
    }

    async edit(id, params) {
        let url = this.prefix + id;
        return await this.put(url, params, {
            'api-action': 'NationalRequest-edit',
            'api-action-meta': params.code
        });
    }

    async destroy(id, code) {
        let url = this.prefix + id;
        return await this.delete(url, {}, {
            'api-action': 'NationalRequest-delete',
            'api-action-meta': code
        });
    }

    async destroyAll(params) {
        let url = this.prefix + 'delete-all';
        return await this.post(url, params, {
            'api-action': 'NationalRequest-deleteAll',
            'api-action-meta': params.length
        });
    }

    async import(params) {
        let url = this.prefix + 'export';
        return await this.get(url, params);
    }

    async checkExist(params) {
        let url = this.prefix + 'check-exist';
        return await this.get(url, params);
    }
}

export default NationalRequest.getInstance()
